<div class="container bulk-style">
  <!-- Container for purchase order upload section -->
  <mat-card appearance="outlined">
    <mat-card-title>Upload spreadsheet to register purchase order details</mat-card-title>

    <!-- Download button with adjusted styles and method -->
    <button
      mat-fab
      (click)="downloadSampleFileForBulkPoDetails()"  
      [disabled]="!isAdminGroupUser"
      class="bulk-download-btn"
      color="accent"
      matTooltip="Download Sample Spreadsheet for bulk purchase order details"
    >
      <!-- Inner span with icon -->
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size: 30px">download</i>
      </span>
    </button>

    <mat-card-subtitle><!-- Subtitle intentionally left blank --></mat-card-subtitle>

    <mat-card-content>
      <div class="col-md-12 form-group">
        <div class="instruction-box">
          <!-- Instructions for uploading cities file -->
          <ul class="instruction-list">
            <li>
              You can upload an Excel file to create purchase order details;
              <span class="highlight">limit is 250 rows</span> per upload.
            </li>
            <li>
              Make sure only the <span class="highlight">first sheet</span> contains data;
              others are ignored.
            </li>
            <li>
              Do <span class="highlight">not rename</span> the sheet;
              use it for purchase order detail information only.
            </li>
            <li>
              <span class="highlight">Avoid changing</span> the column headers;
              always refer to the latest template.
            </li>
            <li>
              Acceptable values must match those from the
              <span class="highlight">provided sample</span> for
              <span class="highlight">Purchase order, Product, Category, Subcategory, Brand, Unit</span> fields.
            </li>
            <li>
              Contact the admin if reference data is unavailable or outdated.
            </li>
            <li>
              Use the <span class="highlight">Download</span> button above
              to get the format. Post-upload, a report will be downloaded.
            </li>
            <!-- Extra dummy instruction to differentiate -->
            <li>
              <!-- Comment: placeholder for future instructions -->
              Please make sure you are uploading a .xlsx format.
            </li>
          </ul>
        </div>
      </div>

      <!-- File upload input -->
      <div class="row">
        <div class="col-md-12 form-group">
          <!-- Wrapper div added for visual uniqueness -->
          <div class="fake-wrapper">
            <input
              type="file"
              class="form-control"
              (change)="onPurchaseOrderDetailsFileUpload($event)"  
              placeholder="Choose file"
              [disabled]="!isAdminGroupUser"
            />
          </div>
        </div>
      </div>

      <!-- Loader area with slight position/style changes -->
      <div *ngIf="isLoaderResult" class="loader">
        <mat-spinner color="warn"></mat-spinner>
      </div>
    </mat-card-content>
  </mat-card>
</div>
